import React, { PropTypes } from 'react';
import PagerMeta from 'common/components/pager_meta';
import { getCanonicalURL } from 'common/utils';
import { getCategory, getSubCategory } from 'common/ducks/categories';

const ProjectMeta = ({ title, project, projectSlug, router, page, categories, customMeta}) => {
  const subCategory = getSubCategory(categories, project.sub_category);
  const category = subCategory ? getCategory(categories.data, project.category) : null;

  let projectTitle = "Loading...";
  let projectDescription = "";

  let meta = [];
  let links = [];

  if (subCategory && category) {
    const subCategorySlug = subCategory.slug;
    const canonicalURL = router.location.pathname.indexOf('entries') > 0
      ? getCanonicalURL(`/${subCategorySlug}/${projectSlug}/entries/`)
      : getCanonicalURL(`/${subCategorySlug}/${projectSlug}/`);

    projectTitle = (
      `${project.title}, a ${category.name} project by ${project.client_username}`
    );

    if (title) {
      projectTitle = `${projectTitle} - ${title}`;
    }

    projectDescription = `${project.title}, a ${subCategory.name} project on crowdspring`;

    links = [{
      rel: 'canonical', href: canonicalURL
    }];

    meta = [
      { property: 'description', content: projectDescription },
      { property: 'og:title', content: projectTitle },
      { property: 'og:url', content: canonicalURL },
      { property: 'og:image', content: project.project_thumbnail ? project.project_thumbnail : 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_fb-share.png' },
    ];
  }

  return (<PagerMeta
    title={projectTitle}
    page={page}
    link={links}
    meta={customMeta ? customMeta : meta.concat(project.search_exclusion ? [{ name: 'robots', content: 'noindex,follow' }] : [])}
  />);
};

ProjectMeta.propTypes = {
  title: PropTypes.string,
  project: PropTypes.object,
  projectSlug: PropTypes.string,
  router: PropTypes.object,
  page: PropTypes.number,
  categories: PropTypes.object,
};

export default ProjectMeta;



// WEBPACK FOOTER //
// ./project/components/meta.jsx